import { jsx as a } from "react/jsx-runtime";
import { ButtonSize as t, FAIcon as l } from "@nextgen-web-framework/all";
import './assets/ButtonLoader.css';const i = "#ffffff", d = "#396e75", c = "#e5fdff", s = "#546223", u = "#f0fae5", z = "#a65523", V = "#fff1e8", g = "#7f3e3e", C = "#ffe2e2", _ = "#62625a", b = "#f8f8e7", f = "#38539a", m = "#707070", h = "#c8f8d1", k = "#87c9c8", B = "#5291b1", x = "rgba(82, 145, 177, 0.1019607843)", p = "#445685", w = "#181d61", G = "rgba(24, 29, 97, 0.1019607843)", O = "#5969d6", R = "#ea999d", W = "#b6577e", y = "rgba(182, 87, 126, 0.1019607843)", v = "#7e3e80", A = "#1e247f", N = "rgba(30, 36, 127, 0.1019607843)", S = "#da7600", Y = "#107f47", $ = "#d91734", L = "_html_l4uxl_38", M = "_spin_l4uxl_1", o = {
  amwayWhite: i,
  darkBlue: d,
  lightBlue: c,
  darkGreen: s,
  lightGreen: u,
  darkOrange: z,
  lightOrange: V,
  darkRed: g,
  lightRed: C,
  darkYellow: _,
  lightYellow: b,
  darkPurple: f,
  darkGrayOnWhite: m,
  dataVizColor1: h,
  dataVizColor2: k,
  dataVizColor3: B,
  dataVizColor3Background: x,
  dataVizColor4: p,
  dataVizColor5: w,
  dataVizColor5Background: G,
  dataVizColor6: O,
  dataVizColor7: R,
  dataVizColor8: W,
  dataVizColor8Background: y,
  dataVizColor9: v,
  dataVizColor10: A,
  dataVizColor10Background: N,
  dataVizAlertOrange: S,
  dataVizSuccessGreen: Y,
  dataVizWarningRed: $,
  "no-visible": "_no-visible_l4uxl_34",
  html: L,
  "button-loader-min-width": "_button-loader-min-width_l4uxl_80",
  "button-loader-container": "_button-loader-container_l4uxl_84",
  "button-loader-container-small": "_button-loader-container-small_l4uxl_93",
  "button-loader-container-medium": "_button-loader-container-medium_l4uxl_96",
  "button-loader-container-icon-container": "_button-loader-container-icon-container_l4uxl_99",
  "button-loader-container-icon": "_button-loader-container-icon_l4uxl_99",
  spin: M
}, j = ({ size: n = t.MEDIUM, className: r, isStepper: e = !1 }) => /* @__PURE__ */ a(
  "div",
  {
    className: `
    ${!e && o["button-loader-min-width"]}
    ${o["button-loader-container"]} ${n === t.SMALL ? o["button-loader-container-small"] : o["button-loader-container-medium"]}
    ${r}
    `,
    children: /* @__PURE__ */ a("div", { className: o["button-loader-container-icon-container"], children: /* @__PURE__ */ a(l, { className: o["button-loader-container-icon"], iconName: "spinner-third" }) })
  }
);
export {
  j as B
};
//# sourceMappingURL=ButtonLoader-cc50829a.mjs.map
